import { cn } from "@/lib/utils";
import { SrIcon } from "@/components/ui/SrIcon";
import type { ReiseProject } from "@/hooks/use-my-tasks";

/**
 * Reisetid (medgått)-gruppen (VIB-909) i «Ny registrering»-oppgavevelgeren.
 * Utskilt fra NewRegistrationPopup for å holde filen under
 * filstørrelsesgrensen (endringssjekk-notat, VIB-1208).
 */
export function ReiseGroupSection({
  projects,
  activeIdx,
  startIdx,
  onSelectProject,
  onHoverIdx,
}: {
  projects: ReiseProject[];
  activeIdx: number;
  startIdx: number;
  onSelectProject: (project: ReiseProject) => void;
  onHoverIdx: (idx: number) => void;
}) {
  if (projects.length === 0) return null;

  return (
    <div>
      <p className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider px-3 xl:px-4 pt-2.5 pb-1">
        Reisetid (medgått)
      </p>
      {projects.map((p, i) => {
        const itemIdx = startIdx + i;
        const isActive = itemIdx === activeIdx;
        return (
          <button
            key={p.id}
            data-idx={itemIdx}
            onClick={() => onSelectProject(p)}
            onMouseEnter={() => onHoverIdx(itemIdx)}
            className={cn(
              "w-full flex items-center gap-2 px-3 xl:px-4 py-2 text-left transition-colors group",
              isActive ? "bg-muted" : "hover:bg-muted/50",
            )}
          >
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium truncate">
                {p.project_code ? `${p.project_code} — ${p.name}` : p.name}
              </p>
              <p className="text-[10px] text-muted-foreground">Reisetid (medgått)</p>
            </div>
            <SrIcon
              name="chevron-right"
              className={cn(
                "w-3.5 h-3.5 text-muted-foreground flex-shrink-0 transition-opacity",
                isActive ? "opacity-100" : "opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100",
              )}
            />
          </button>
        );
      })}
    </div>
  );
}
